import { useEffect, useRef } from "react";

const SovnPage = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadPitchDeck = async () => {
      try {
        const response = await fetch("/sovn-pitch.html");
        const htmlText = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, "text/html");
        
        // Get all styles from head
        const headStyles = Array.from(doc.head.querySelectorAll("style"));
        const headLinks = Array.from(doc.head.querySelectorAll("link"));
        
        // Add font links first
        headLinks.forEach((link) => {
          const newLink = document.createElement("link");
          newLink.rel = link.getAttribute("rel") || "";
          newLink.href = link.getAttribute("href") || "";
          if (link.getAttribute("crossorigin")) {
            newLink.crossOrigin = link.getAttribute("crossorigin") || "";
          }
          document.head.appendChild(newLink);
        });
        
        // Add all styles from head
        const addedStyles: HTMLStyleElement[] = [];
        headStyles.forEach((style) => {
          const newStyle = document.createElement("style");
          newStyle.textContent = style.textContent;
          document.head.appendChild(newStyle);
          addedStyles.push(newStyle);
        });
        
        // Move all body content to our container
        if (containerRef.current) {
          containerRef.current.innerHTML = doc.body.innerHTML;
          
          // Remove script tags from innerHTML and execute them separately
          const scriptTags = containerRef.current.querySelectorAll("script");
          scriptTags.forEach((oldScript) => {
            const newScript = document.createElement("script");
            if (oldScript.src) {
              newScript.src = oldScript.src;
            } else if (oldScript.textContent) {
              newScript.textContent = oldScript.textContent;
            }
            document.body.appendChild(newScript);
            oldScript.remove();
          });
        }
        
        // Cleanup
        return () => {
          addedStyles.forEach((style) => style.remove());
          headLinks.forEach((_, i) => {
            const links = document.querySelectorAll(`link[href*="fonts.googleapis"], link[href*="fonts.gstatic"]`);
            links.forEach((link) => link.remove());
          });
        };
      } catch (error) {
        console.error("Error loading pitch deck:", error);
      }
    };

    loadPitchDeck();
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        inset: 0,
        background: "#07090f",
        zIndex: 50,
      }}
    />
  );
};

export default SovnPage;
